import { render, staticRenderFns } from "./Goodslist.vue?vue&type=template&id=4beded6d&scoped=true&"
import script from "./Goodslist.vue?vue&type=script&lang=js&"
export * from "./Goodslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beded6d",
  null
  
)

export default component.exports